import React, { useState, useMemo, useCallback } from 'react';
import { GroupOptionSelection } from 'components/common/GroupOptionSelection/GroupOptionSelection';
import { DefaultGroupOptionSelectionModel } from 'components/common/GroupOptionSelection/GroupOptionSelectionModel';
import Cookies from 'universal-cookie';
import {
  SessionStorageHelper,
  SessionStorageItemKeys
} from 'helper/StorageHelper';
import i18n from 'i18next';
import _ from 'lodash';
import { useCoreContext } from 'contexts/coreContext';
import { RoleNames } from 'core';

const cookies = new Cookies();

export const RecentGroupDropdown: React.FC<any> = ({
  storageKey,
  options,
  value,
  callback,
  showShowAllBtn,
  useCustomStyle
}) => {
  const localStorageKey = useMemo(
    () => `${storageKey}ListOf${cookies.get('actor')}`,
    [storageKey]
  );

  const core = useCoreContext();
  const actor = core?.authenticationManager.actor;
  const isBeaconRoles = [
    RoleNames.beaconAdmin,
    RoleNames.beaconExecutive
  ].includes((actor?.roleName || '') as RoleNames);
  const i18nKey = useMemo(() => {
    // if (isBeaconRoles && storageKey === SessionStorageItemKeys.ADVERTISER) {
    //   return 'merchantId';
    // }
    // if (isBeaconRoles && storageKey === SessionStorageItemKeys.AGENCY) {
    //   return 'restaurantId';
    // }
    if (isBeaconRoles && storageKey === SessionStorageItemKeys.AGENCY) {
      return 'merchantId';
    }
    return storageKey;
  }, [isBeaconRoles, storageKey]);

  const [recentOptions, setRecentOptions] = useState<string[]>(() => {
    const recentOptionsString = localStorage.getItem(localStorageKey);
    return recentOptionsString === null ? [] : recentOptionsString.split(',');
  });

  const updateRecentOptions = useCallback(
    (value: number | undefined) => {
      if (value) {
        let newRecentOptions;
        const recentOptionsString = localStorage.getItem(localStorageKey);
        if (recentOptionsString === null) {
          newRecentOptions = [value.toString()];
        } else {
          newRecentOptions = recentOptionsString.split(',');
          _.remove(
            newRecentOptions,
            (recentOption) => recentOption === value.toString()
          );
          newRecentOptions.length === 5 && newRecentOptions.pop();
          newRecentOptions.unshift(value.toString());
        }
        localStorage.setItem(localStorageKey, newRecentOptions.join(','));
        setRecentOptions(newRecentOptions);
      }
    },
    [localStorageKey]
  );

  const onOptionSelected = useCallback(
    (value?: number) => {
      if (value) {
        SessionStorageHelper.setItem(storageKey, value);
      } else {
        SessionStorageHelper.removeItem(storageKey);
      }
      updateRecentOptions(value);
      callback(value);
    },
    [storageKey, callback, updateRecentOptions]
  );

  const getGroupOptions = (): {
    [groupTitle: string]: Array<SelectOptions>;
  } => {
    const selectOptions = options ? options : [];
    const groupOptions = {};
    const recentUseGroup: Array<SelectOptions> = [];
    recentOptions.forEach((recentOption) => {
      const findOption: SelectOptions | undefined = selectOptions.find(
        (option) => option.value.toString() === recentOption
      );
      findOption && recentUseGroup.push(findOption);
    });
    groupOptions[i18n.t('recentGroupDropdown.labels.useRecently')] =
      recentUseGroup;
    groupOptions[
      i18n.t(`recentGroupDropdown.labels.${_.camelCase('other-' + i18nKey)}`)
    ] = _.xorWith(
      selectOptions,
      recentUseGroup,
      (optionA, optionB) => optionA.value === optionB.value
    );
    return groupOptions;
  };

  return (
    <GroupOptionSelection
      model={
        new DefaultGroupOptionSelectionModel(
          value,
          getGroupOptions(),
          onOptionSelected,
          i18nKey,
          showShowAllBtn,
          useCustomStyle
        )
      }
    />
  );
};
